/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

import Prize from './Prize';

import styles from '../../../styles/partials/prizes.module.scss';

const propTypes = {
    className: PropTypes.string,
    prizes: AppPropTypes.prizes,
    prizeTitle: PropTypes.string,
};

const defaultProps = {
    className: null,
    prizes: null,
    prizeTitle: null,
};

function Prizes({ className, prizes, prizeTitle, ...prizeProps }) {
    return (
        <div className={classNames([styles.container, { [className]: className !== null }])}>
            {(prizes || []).map((prize) => (
                <Prize
                    key={`prize-${prize.id}`}
                    className={styles.prize}
                    prize={prize}
                    prizeTitle={prizeTitle}
                    {...prizeProps}
                />
            ))}
        </div>
    );
}

Prizes.propTypes = propTypes;
Prizes.defaultProps = defaultProps;

export default Prizes;
